var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tripDetails != null
    ? _c("div", { staticClass: "details-page" }, [
        _c("div", { staticClass: "md-layout" }, [
          _c("div", { staticClass: "md-layout-item" }, [
            _c("div", { staticClass: "custom-toolbar" }, [
              !_vm.$root.isMobileOnly && !_vm.isReadOnlyUser
                ? _c("div", { staticClass: "custom-toolbar-end" }, [
                    _c(
                      "div",
                      { staticClass: "header-button-container" },
                      [
                        _c("trip-status-button", {
                          staticClass: "status-btn",
                          attrs: {
                            trip: _vm.tripDetails,
                            "is-modal": false,
                            "class-name": "md-sm",
                          },
                          on: {
                            statusUpdated: _vm.handleChangedTripStatus,
                            statusHistoryUpdated:
                              _vm.handleTripStatusHistoryUpdated,
                          },
                        }),
                        _c(
                          "md-button",
                          {
                            attrs: { title: "Reassign Trip" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.reassignTrip($event)
                              },
                            },
                          },
                          [_c("span", [_vm._v("Reassign Trip")])]
                        ),
                        _c(
                          "md-button",
                          {
                            attrs: { title: "Edit trip details" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleTripUpdate($event)
                              },
                            },
                          },
                          [_c("span", [_vm._v("Edit")])]
                        ),
                        _vm.tripDetails.stopList.length > 0
                          ? _c("generate-label-button", {
                              attrs: {
                                id: _vm.tripDetails.tripId,
                                "use-icon": false,
                                type: "Trip",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "md-layout md-alignment-top-left content-layout-panel",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-50",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100 md-xlarge-size-100",
                  },
                  [
                    _c(
                      "md-card",
                      [
                        _c(
                          "md-card-header",
                          {
                            staticClass:
                              "md-card-header-icon md-card-header-blue",
                          },
                          [
                            _vm.tripDetails.assignedTo.photoUrl === null
                              ? _c(
                                  "div",
                                  { staticClass: "card-icon" },
                                  [_c("md-icon", [_vm._v("description")])],
                                  1
                                )
                              : _vm._e(),
                            _vm.tripDetails.assignedTo.photoUrl !== null
                              ? _c(
                                  "div",
                                  { staticClass: "card-icon profile-image" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.tripDetails.assignedTo
                                          .photoUrl,
                                        alt: "avatar",
                                      },
                                      on: {
                                        error: _vm.$_setDefaultBrokenImage,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c("md-card-content", [
                          _c(
                            "div",
                            { staticClass: "single-row three-column-box" },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-md-field details-box" },
                                [
                                  _c("div", { staticClass: "custom-label" }, [
                                    _vm._v("Driver"),
                                  ]),
                                  _vm.tripDetails.assignedTo.publicUserId
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "Team Member Profile",
                                              params: {
                                                publicUserId:
                                                  _vm.tripDetails.assignedTo
                                                    .publicUserId,
                                              },
                                            },
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.tripDetails.assignedTo
                                                  .fullName ||
                                                  _vm.tripDetails.assignedTo
                                                    .publicUserId
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          attrs: { title: "Reassign Trip" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.reassignTrip($event)
                                            },
                                          },
                                        },
                                        [_vm._v("Unassigned")]
                                      ),
                                ],
                                1
                              ),
                              !_vm.tripDetails.rateGroupId &&
                              _vm.tripDetails.assignedTo.rateGroupId &&
                              _vm.showServicePackage()
                                ? _c("div", { staticClass: "details-box" }, [
                                    _c("label", [
                                      _vm._v("Driver Service Package"),
                                    ]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.tripDetails.assignedTo
                                              .rateGroupName
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Trip Date")]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          _vm.tripDetails.tripDate,
                                          _vm.DATE_TYPES.standardDate
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm.tripDetails.completedDate
                                ? _c("div", { staticClass: "details-box" }, [
                                    _c("label", [_vm._v("Completed Date")]),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm._f("dateTimeFormat")(
                                              _vm.tripDetails.completedDate,
                                              _vm.DATE_TYPES.standardDate
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "single-row three-column-box" },
                            [
                              _vm.tripDetails.startTime
                                ? _c("div", { staticClass: "details-box" }, [
                                    _c("label", [_vm._v("Start Time")]),
                                    _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.convertTimeFormat(
                                              _vm.tripDetails.startTime
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.tripDetails.actualStartTime
                                ? _c("div", { staticClass: "details-box" }, [
                                    _c("label", [_vm._v("Actual Start Time")]),
                                    _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm._f("dateTimeFormat")(
                                              _vm.tripDetails.actualStartTime,
                                              _vm.DATE_TYPES.standardDate
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Start Location")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.tripDetails.locationDetails
                                        .startAddress
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "single-row three-column-box" },
                            [
                              _vm.tripDetails.endTime
                                ? _c("div", { staticClass: "details-box" }, [
                                    _vm.tripDetails.endTime != null
                                      ? _c("label", [_vm._v("End Time")])
                                      : _vm._e(),
                                    _vm.tripDetails.endTime != null
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.convertTimeFormat(
                                                  _vm.tripDetails.endTime
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              _vm.tripDetails.actualEndTime &&
                              _vm.tripDetails.status === "Complete"
                                ? _c("div", { staticClass: "details-box" }, [
                                    _c("label", [_vm._v("Actual End Time")]),
                                    _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm._f("dateTimeFormat")(
                                              _vm.tripDetails.actualEndTime,
                                              _vm.DATE_TYPES.standardDate
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "details-box" }, [
                                _vm.tripDetails.locationDetails.endAddress !=
                                null
                                  ? _c("label", [_vm._v("End Location")])
                                  : _vm._e(),
                                _vm.tripDetails.locationDetails.endAddress !=
                                null
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.tripDetails.locationDetails
                                              .endAddress
                                          ) +
                                          "\n                                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm.teamRegionName
                            ? _c("div", { staticClass: "single-row" }, [
                                _c("div", { staticClass: "details-box" }, [
                                  _c("label", [_vm._v("Team Region")]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.teamRegionName)),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.tripDetails.rateGroupName ||
                          _vm.showRunScheduleInfo
                            ? _c("div", { class: _vm.servicePackageRowClass }, [
                                _vm.tripDetails.rateGroupName
                                  ? _c("div", { staticClass: "details-box" }, [
                                      _c("label", [_vm._v("Service Package")]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.tripDetails.rateGroupName)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.showRunScheduleInfo
                                  ? _c("div", { staticClass: "details-box" }, [
                                      _c("label", [
                                        _vm._v("Run Schedule (Run Number)"),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.formattedRunScheduleList)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm.tripDetails.customerInvoiceId
                            ? _c("div", { staticClass: "details-box" }, [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Customer Invoice:"),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class:
                                          "custom-badge payment-status-" +
                                          _vm.tripDetails.customerInvoiceStatus
                                            .toLowerCase()
                                            .replace(/\s+/g, ""),
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "inputs.paymentStatuses." +
                                                  _vm.tripDetails
                                                    .customerInvoiceStatus
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "Customer Invoice Details",
                                            params: {
                                              invoiceId:
                                                _vm.tripDetails
                                                  .customerInvoiceId,
                                            },
                                          },
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.tripDetails
                                                .customerInvoiceNumber
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.tripDetails.teamMemberInvoiceId
                            ? _c("div", { staticClass: "details-box" }, [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Team Member Invoice:"),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class:
                                          "custom-badge payment-status-" +
                                          _vm.tripDetails.teamMemberInvoiceStatus
                                            .toLowerCase()
                                            .replace(/\s+/g, ""),
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "inputs.paymentStatuses." +
                                                  _vm.tripDetails
                                                    .teamMemberInvoiceStatus
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "Team Member Invoice Details",
                                            params: {
                                              invoiceId:
                                                _vm.tripDetails
                                                  .teamMemberInvoiceId,
                                            },
                                          },
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.tripDetails
                                                .teamMemberInvoiceNumber
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 map-box",
                  },
                  [
                    _c("map-box-overlay", {
                      attrs: {
                        details: _vm.tripDetails,
                        type: "trip",
                        "clicked-history": _vm.clickedHistory,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide",
                  },
                  [
                    _c("notes", {
                      attrs: {
                        list: _vm.tripDetails.notes,
                        "trip-id": _vm.tripDetails.tripId,
                      },
                      on: { notesAdded: _vm.handleAddedTripNote },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-hide",
                  },
                  [
                    _c("stop-list-table", {
                      attrs: { "trip-details": _vm.stopListData },
                    }),
                  ],
                  1
                ),
                _vm.tripDetails.driverBreakList &&
                _vm.tripDetails.driverBreakList.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-hide",
                      },
                      [
                        _c("driver-break-list-table", {
                          attrs: { "trip-details": _vm.stopListData },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canViewHistory
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                      },
                      [
                        _c(
                          "md-card",
                          { staticClass: "history-section" },
                          [
                            _c(
                              "md-card-content",
                              [
                                _c("history-component", {
                                  ref: "historyComponent",
                                  attrs: {
                                    "view-type":
                                      _vm.CHANGE_HISTORY_VIEW_TYPES.TRIP,
                                    "entity-id": _vm.tripDetails.tripId,
                                    "page-size": 15,
                                    title: "Trip Change History",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-small-size-100 md-layout md-medium-size-100 md-large-size-33 md-xlarge-size-50",
              },
              [
                _vm.tripDetails.contact
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xlarge-hide",
                      },
                      [
                        _c("trip-contact-details", {
                          attrs: { "trip-details": _vm.tripDetails },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xlarge-hide",
                  },
                  [
                    _c("assignment-history-timeline", {
                      attrs: { list: _vm.tripDetails.tripUserHistory },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xlarge-hide",
                  },
                  [
                    _c(
                      "md-card",
                      [
                        _c(
                          "md-card-header",
                          {
                            staticClass:
                              "md-card-header-icon md-card-header-warning",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-icon" },
                              [_c("md-icon", [_vm._v("history")])],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "md-card-content",
                          [
                            _vm.tripDetails.statusHistory.length > 0
                              ? _c(
                                  "time-line",
                                  { attrs: { plain: "", type: "simple" } },
                                  _vm._l(
                                    _vm.tripDetails.statusHistory,
                                    function (history, index) {
                                      return _c(
                                        "time-line-item",
                                        {
                                          key: index,
                                          attrs: {
                                            inverted: "",
                                            "badge-type":
                                              "status-" +
                                              history.newStatus
                                                .toLowerCase()
                                                .replace(/\s+/g, ""),
                                            "badge-icon": "place",
                                            "is-clickable": true,
                                          },
                                          on: {
                                            clicked: function ($event) {
                                              return _vm.showHistoryInMap(
                                                history
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "badge",
                                              class:
                                                "status-" +
                                                history.newStatus
                                                  .toLowerCase()
                                                  .replace(/\s+/g, ""),
                                              attrs: { slot: "header" },
                                              slot: "header",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(history.newStatus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "time",
                                              attrs: { slot: "headerTime" },
                                              slot: "headerTime",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm._f("dateTimeFormat")(
                                                      history.actionDate,
                                                      _vm.DATE_TYPES
                                                        .standardDate
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "h6",
                                            {
                                              attrs: { slot: "footer" },
                                              slot: "footer",
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "ti-time",
                                              }),
                                              _vm._v(
                                                "\n\n                                    By " +
                                                  _vm._s(
                                                    history.changedByUserFullName
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c("p", { staticClass: "grayedout-text" }, [
                                  _vm._v("No Status History Available"),
                                ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-50 md-xlarge-hide",
                  },
                  [
                    _c("notes", {
                      staticClass: "custom-note-card-large",
                      attrs: {
                        list: _vm.tripDetails.notes,
                        "trip-id": _vm.tripDetails.tripId,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide",
                  },
                  [
                    _c("stop-list-table", {
                      attrs: { "trip-details": _vm.stopListData },
                    }),
                  ],
                  1
                ),
                _vm.tripDetails.driverBreakList &&
                _vm.tripDetails.driverBreakList.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide",
                      },
                      [
                        _c("driver-break-list-table", {
                          attrs: { "trip-details": _vm.tripDetails },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide",
                  },
                  [
                    _c("assignment-history-timeline", {
                      attrs: { list: _vm.tripDetails.tripUserHistory },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide",
                  },
                  [
                    _c("status-history-timeline", {
                      attrs: { list: _vm.tripDetails.statusHistory },
                    }),
                  ],
                  1
                ),
                !_vm.isIndividualUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                      },
                      [
                        (_vm.tripDetails.chargeLines.length > 0 ||
                          _vm.tripDetails.customerId ||
                          _vm.services.length > 0) &&
                        (_vm.canAccessRates ||
                          _vm.isAdmin ||
                          _vm.isReadOnlyUser)
                          ? _c("trip-charge-rates-list", {
                              attrs: {
                                "charge-lines": _vm.tripDetails.chargeLines,
                                services: _vm.services,
                                "trip-details": _vm.tripDetails,
                                title: "Trip Charges",
                                "has-invoice":
                                  _vm.tripDetails.customerInvoiceId !== null,
                                "rates-have-changed": false,
                              },
                              on: {
                                updateTripDetails: _vm.handleChargesUpdated,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isIndividualUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                      },
                      [
                        (_vm.tripDetails.costLines.length > 0 ||
                          _vm.tripDetails.publicUserId) &&
                        (_vm.canAccessRates || _vm.isAdmin)
                          ? _c("trip-cost-rates-list", {
                              attrs: {
                                "cost-lines": _vm.tripDetails.costLines,
                                services: _vm.services,
                                "trip-details": _vm.tripDetails,
                                title: "Trip Costs",
                                "has-invoice":
                                  _vm.tripDetails.teamMemberInvoiceId !== null,
                                "rates-have-changed": false,
                              },
                              on: { updateTripDetails: _vm.handleCostsUpdated },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                  },
                  [
                    _c("trip-services", {
                      attrs: {
                        services: _vm.services,
                        "is-invoiced":
                          _vm.tripDetails.customerInvoiceId !== null ||
                          _vm.tripDetails.teamMemberInvoiceId !== null,
                        "trip-id": _vm.tripDetails.tripId,
                      },
                      on: { serviceUpdated: _vm.handleServicesUpdated },
                    }),
                  ],
                  1
                ),
                !_vm.isReadOnlyUser && _vm.items.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                      },
                      [
                        _c("trip-items", {
                          attrs: { items: _vm.items },
                          on: { itemUpdated: _vm.getTripDetails },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canCreateIssue
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "feature",
                            rawName: "v-feature",
                            value: _vm.FEATURE_NAMES.IssueTracking,
                            expression: "FEATURE_NAMES.IssueTracking",
                          },
                        ],
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                      },
                      [
                        _c("review-invoice-issues", {
                          attrs: {
                            issues: _vm.tripDetails.tripIssues,
                            "entity-ref": _vm.tripDetails.tripRef,
                            "entity-id": _vm.tripDetails.tripId,
                            "entity-type": "Trip",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }